// extracted by mini-css-extract-plugin
module.exports = {"swiper":"banner_swiper__s7ONX"};